import { useState } from 'react';

import { listGroupedFiles } from 'services/fileManager/fileManagerServices';

export default function useFetchFiles() {
  const [files, setFiles] = useState([]);
  const [filesLoading, setfilesLoading] = useState(false);

  const handleSetFiles = (updateFn) => {
    setFiles((prevFiles) => {
      const updatedFiles = typeof updateFn === 'function' ? updateFn(prevFiles) : updateFn;
      return { ...updatedFiles };
    });
  };

  const getFiles = (obj) => {
    listGroupedFiles(obj)
      .then(async (response) => {
        let arr = response.data;
        setFiles(arr);
        setfilesLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setfilesLoading(false);
      });
  };

  return {
    files,
    getFiles,
    handleSetFiles,
    filesLoading,
  };
}
